<!-- eslint-disable -->
<template>
    <div>
        <div class="svgpanzoom-container" v-html="svg"></div>
    </div>    
</template>

<script>
export default {
    props: ['svg']
}
</script>
